import DOMPurify from "dompurify";

// Survey question text/descriptions are stored as TipTap rich-text HTML and
// rendered to respondents with dangerouslySetInnerHTML. Sanitize at render
// time so HTML authored by one user can never execute script in another
// user's browser (stored XSS).
const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "div", "span",
    "strong", "b", "em", "i", "u", "s", "strike",
    "a", "mark", "sup", "sub", "code", "pre", "blockquote",
    "ul", "ol", "li",
    "h1", "h2", "h3", "h4", "h5", "h6",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "style", "class", "dir"],
};

// Links opened from survey content must not get a handle on our window,
// and javascript:/data: URLs are already stripped by DOMPurify defaults.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export const sanitizeRichText = (html) => {
  if (html === null || html === undefined) return html;
  return DOMPurify.sanitize(String(html), RICH_TEXT_CONFIG);
};

// Respondent answers rendered as HTML in the analytics table (file uploads,
// picture choices, signatures). Escaping alone doesn't stop a crafted
// answer like {url: "javascript:..."} from becoming a live link, so run the
// markup through DOMPurify, which drops javascript:/vbscript: URLs but keeps
// https: links and data:image signatures.
const ANSWER_TABLE_CONFIG = {
  ALLOWED_TAGS: ["div", "span", "p", "b", "strong", "a", "img"],
  ALLOWED_ATTR: ["href", "target", "rel", "class", "src", "alt", "loading"],
};

export const sanitizeAnswerHtml = (html) => {
  if (html === null || html === undefined) return html;
  return DOMPurify.sanitize(String(html), ANSWER_TABLE_CONFIG);
};

// Question titles are stored as rich-text HTML. In places that must show a
// plain-text label (e.g. analytics table headers), strip all markup so the
// user never sees raw tags like "<strong>" rendered as literal text.
export const stripHtmlToText = (html) => {
  if (html === null || html === undefined) return html;
  return DOMPurify.sanitize(String(html), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};

export default sanitizeRichText;
